import axios, {AxiosResponse} from 'axios'
import {Request, Response} from 'express'
import {TestOutput} from './models/testModels'
import {Result} from '../../resultModel'
import {TESTS_BY_ID_GETURL} from '../../endpoints'
import {RequestManager} from '../../RequestManager'

export const getTestById = async (id: number) => {
  const requestManager = new RequestManager()

  var res: Result<TestOutput> = {success: false, message: 'Hata', data: null}
  return requestManager
    .get<Result<TestOutput>>(TESTS_BY_ID_GETURL(id))
    .then((response) => {
      ////debugger
      res = response
      return res
    })
    .catch((error) => {
      res.message = error.message
      return res
    })
}
